module.exports = __webpack_public_path__ + "static/media/ChinguProd2.9fea6a00.png";